import EventBus, { EVENTS } from '../eventBus';
import { reactive } from '@mimir/web/compat/vueCompat';
import type { GeneralDialogCommand } from './showDialogCommand';
import type { DialogRequest } from './types';

// A `req` written to after this call must come from createReactiveDialogRequest().
export function requestDialog(req: DialogRequest, component: unknown) {
  const command: GeneralDialogCommand = {
    type: 'general',
    req: {
      requestData: req,
      component,
    },
  };
  EventBus.emit(EVENTS.SHOW_DIALOG, command);
}

/**
 * Creates a dialog request that the caller can keep writing to after showing the dialog
 * (showDialog, loading, bootstrapping, ...). Vue 3 tracks only writes made through the returned
 * reactive object, never through the object passed in, so the caller must keep and use the result.
 */
export function createReactiveDialogRequest<T extends DialogRequest>(request: T) {
  // Vue 3 types the result as UnwrapNestedRefs<T>, which is T itself because requests hold no refs.
  return reactive(request);
}
